<template>
  <div class="StaffManage-list">
    <GlobalInfoBar title="赠品管理" content="添加礼包里的赠品内容" />
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <From @seeExample="seeExample" />
      </div>
      <Table @seeExample="seeExample" />
    </GlobalChunk>
    <el-image-viewer
      style="z-index:999999999"
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false;
        }
      "
      :url-list="imgList"
    />
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: {
    From: () => import("./from"),
    Table: () => import("./table"),
    ElImageViewer,
  },
  data() {
    return {
      showViewer: false,
      imgList: [],
    };
  },
  created() {},
  mounted() {},
  methods: {
    seeExample(type) {
      this.imgList =
        type == "01"
          ? ["https://pic.imgdb.cn/item/63e490a54757feff33f2dcf8.png"]
          : ["https://pic.imgdb.cn/item/63e490a54757feff33f2dccb.png"];
      this.showViewer = true;
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
/deep/.el-image-viewer__wrapper {
  z-index: 9999999999 !important;
}
</style>
